import React, { useContext, useEffect, useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { getQuestionsAnswerState } from 'chameleon/packages/blue-book-player/utils';
import QuestionsReview from 'chameleon/packages/blue-book-player/library/QuestionsReview';
import NavigatorLegend from '../library/QuestionNavigator/NavigatorLegend';
import { BluebookContext } from '../state/BluebookContext';
import { SET_IS_REVIEW_PAGE } from '../state/reducer';

const QuestionsList = (props) => {
  const [questionsData, setQuestionsData] = useState([]);
  const { learnosityApp } = props;
  const { state: playerState, dispatch } = useContext(BluebookContext);

  const handleCloseReviewPage = () => {
    dispatch({ type: SET_IS_REVIEW_PAGE, payload: false });
  };

  useEffect(() => {
    const responses = learnosityApp?.getResponses();
    const learnosityItems = learnosityApp?.getItems();
    const questions = Object.keys(learnosityItems || {});

    setQuestionsData(
      getQuestionsAnswerState(learnosityItems, questions, responses),
    );
  }, [learnosityApp]);

  const handleItemGoTo = (reference) => {
    learnosityApp?.items()?.goto(reference);
    handleCloseReviewPage();
  };

  const POPOVER_HEADER_CLASSES =
    'mx-[3px] border-b border-bluebook-gray4 py-[8px] flex justify-around flex-row';

  return (
    <div
      className="max-w-[868px] px-[21px] text-center h-auto"
      aria-label="Question Menu"
      role="region"
    >
      <div className={cn(POPOVER_HEADER_CLASSES)}>
        <div className="leading-[1.16] text-[19px] text-center py-[12px] px-[5px] font-bold grow-[2] shrink-[1] basis-0 flex justify-between items-center">
          <h2 className="m-0 leading-[1.16] text-[19px]">
            {playerState.title + ' Questions'}
          </h2>

          <div className="shrink-0 mx-[3px] py-[8px] flex justify-around flex-row">
            <NavigatorLegend />
          </div>
        </div>
      </div>
      <div className={cn('py-[12px] max-h-[calc(100vh-500px)] overflow-auto')}>
        <QuestionsReview
          questions={questionsData}
          isCompact={false}
          itemGoTo={handleItemGoTo}
        />
      </div>
    </div>
  );
};

QuestionsList.propTypes = {
  learnosityApp: PropTypes.object,
};

QuestionsList.defaultProps = {
  learnosityApp: null,
};

export default QuestionsList;
